import { render } from "./GmailThreadMailsViewer.vue?vue&type=template&id=6cccb2f6"
import script from "./GmailThreadMailsViewer.vue?vue&type=script&lang=js"
export * from "./GmailThreadMailsViewer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__